export default {"src":"/_next/static/media/MobileArrowRight.6b385314.svg","height":38,"width":14,"blurWidth":0,"blurHeight":0};